import { IDL } from "../types/club_program";
import { AnchorProvider, Program } from "@project-serum/anchor";
import { Connection } from "@solana/web3.js";
import { AnchorWallet } from "@solana/wallet-adapter-react";

const SOLANA_ENDPOINT = process.env.REACT_APP_BLOCKCHAIN_NETWORK_URL as string;

export const RPC_CONNECTION = new Connection(SOLANA_ENDPOINT, "processed");

const CLUB_PROGRAM = process.env.REACT_APP_CLUB_PROGRAM as string;

const SECRET_KEY_ARRAY: Uint8Array = new Uint8Array([
  165, 112, 248, 153, 73, 228, 179, 91, 59, 251, 97, 251, 131, 190, 126, 136,
  53, 56, 152, 125, 179, 15, 248, 103, 15, 112, 151, 40, 158, 100, 142, 118,
  239, 251, 12, 66, 156, 162, 168, 29, 205, 233, 192, 137, 43, 36, 140, 158,
  240, 6, 103, 113, 43, 187, 2, 120, 54, 179, 200, 6, 107, 80, 116, 144,
]);

// const nodeWallet = new NodeWallet(Keypair.fromSecretKey(SECRET_KEY_ARRAY));

export const programFactory = (wallet: AnchorWallet) => {
  return new Program(
    IDL,
    CLUB_PROGRAM,
    new AnchorProvider(RPC_CONNECTION, wallet, {
      commitment: "processed",
    })
  );
};
